//Modules
import { useNavigate } from "react-router-dom";

//Utils
import { getLangRoute } from "../../utils/utilFunctions"

function TopLang({ route, menuLang }) {
  const navigate = useNavigate()
  const lang = route.substring(1,3)

  const changeLang = (langTo) => {
  const routeTo = getLangRoute(route, menuLang, langTo)
    navigate(routeTo)
  }

  return (
    <div className='langButton'>
      {lang === 'pt' ?
      <span onClick={() => changeLang("en")}>EN</span>
      :
      <span onClick={() => changeLang("pt")}>PT</span>}      
    </div>
  )
}

export default TopLang